import React, { useState, useEffect } from "react";
import { Container, Row, Col, Spinner } from "reactstrap";
import Alert from "react-bootstrap/Alert";
import Footer from "../components/Footer";
import RegistrationHeader from "../components/registration/RegistrationHeader";
import {
  getFormSteps,
  defaultFormData,
} from "../components/registration/formStepsV3";
import { Wizard } from "react-formik-step-wizard";
import WizardWrapper from "../components/registration/WizardWrapper";
import WizardFooter from "../components/registration/WizardFooterV3";
import "../assets/css/wizard.css";
import Swal from "sweetalert2";

const baseUrl = process.env.REACT_APP_BASE_URL;

// Keys that belong to the user portal - clear only these on logout
const USER_PORTAL_KEYS = [
  'token', 'userid', 'email', 'licenseId', 'rrr',
  'formid', 'DOB', 'surname', 'firstName', 'title', 'gender', 'state', 'lga',
  'recid', 'amount', 'description', 'category', 'serviceTypeId',
  'license_id', 'lead_food_scientist', 'license_number', 'reg_number',
  'nationality', 'orgName', 'orgAddress', 'processEquipm', 'productBrands',
  'natureBus', 'companySize', 'code', 'reset-phone', 'user-reset-id',
  'paymentSuccessful', 'remita-id', 'payment_category', 'paymentsubcategory'
];

export default function RegisterFoodScientistV3(props) {
  const [formData, setFormData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isReturned, setIsReturned] = useState(false);

  useEffect(() => {
    const loadExistingData = async () => {
      const userId = localStorage.getItem("userid");
      const token = localStorage.getItem("token");

      // If user is logged in, try to load their existing registration data
      if (userId && token) {
        try {
          const response = await fetch(
            `${baseUrl}/v2/registration/register/registration-information?userId=${userId}`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.ok) {
            const data = await response.json();
            // Check if this is a returned application
            if (data.applicationStatus?.toLowerCase() === "returned") {
              setIsReturned(true);
            }
            // Store in sessionStorage for the wizard to use
            sessionStorage.setItem("registration:ongoing", JSON.stringify(data));
            sessionStorage.setItem("registration:userId", JSON.stringify(userId));
            setFormData(data);
          } else {
            // User may not have existing registration, use default
            loadFromSessionOrDefault();
          }
        } catch (error) {
          console.error("Failed to load existing registration:", error);
          loadFromSessionOrDefault();
        }
      } else {
        loadFromSessionOrDefault();
      }

      setIsLoading(false);
    };

    const loadFromSessionOrDefault = () => {
      const ongoingJsonFormData = sessionStorage.getItem("registration:ongoing");
      if (ongoingJsonFormData) {
        setFormData(JSON.parse(ongoingJsonFormData));
      } else {
        setFormData(defaultFormData);
      }
    };

    loadExistingData();
  }, []);

  const SaveData = async (values, endpoint) => {
    // do nothing
  };

  const submitForm = (values) => {
    sessionStorage.clear();
    // Clear only user portal keys to avoid affecting company portal session
    USER_PORTAL_KEYS.forEach(key => localStorage.removeItem(key));
    Swal.fire({
      html: "Form successfully submitted",
      icon: "success",
      timer: 4000,
      timerProgressBar: true,
      showConfirmButton: false,
      showCancelButton: false,
      showCloseButton: true,
    });
  };

  const informationUpdateNotice = () => {
    return (
      <Alert
        className="text-light font-weight-bold"
        variant="warning"
        dismissible={true}
      >
        <Alert.Heading className="text-light text-center">
          Your entered details will be automatically saved each time you click
          the 'NEXT' button
        </Alert.Heading>
        <p className="text-center">
          <a
            href="https://nicfost.gov.ng/registration-instructions/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-light font-weight-bold  "
          >
            Read registration instructions here.
          </a>
        </p>
      </Alert>
    );
  };

  const returnedNotice = () => {
    return (
      <Alert
        className="font-weight-bold"
        variant="warning"
        dismissible={false}
      >
        <Alert.Heading className="text-center">
          Your registration has been returned for correction
        </Alert.Heading>
        <p className="text-center">
          Please review and update your information, then resubmit your application.
        </p>
      </Alert>
    );
  };

  if (isLoading) {
    return (
      <Container style={{ alignSelf: "center" }}>
        <main className="main-content h-100 border-radius-lg w-100 my-5">
          <RegistrationHeader />
          <Container>
            <Row>
              <Col md={12} className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-3">Loading registration data...</p>
              </Col>
            </Row>
          </Container>
          <Footer />
        </main>
      </Container>
    );
  }

  const formSteps = getFormSteps(formData);

  return (
    <Container style={{ alignSelf: "center" }}>
      <main className="main-content h-100 border-radius-lg w-100 my-5">
        <RegistrationHeader />
        <Container>
          <Row>
            <Col md={12}>
              {isReturned && returnedNotice()}
              {informationUpdateNotice()}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="mb-2">
                {/* form content start --> */}
                <Wizard
                  steps={formSteps}
                  onStepChanged={(fromStep, toStep, wizardValues) => {
                    SaveData(wizardValues[fromStep?.id], fromStep?.endpoint);
                  }}
                  onCompleted={submitForm}
                  wrapper={
                    <WizardWrapper
                      steps={formSteps}
                      title=""
                      subtitle="Application for Registration as a Certified Food Scientist of Nigeria (CFSN)"
                    />
                  }
                  footer={<WizardFooter />}
                />
              </div>
            </Col>
          </Row>
        </Container>
        <Footer />
      </main>
    </Container>
  );
}
